import { Box } from '@mui/material';
import DocHead from 'components/DocHead/DocHead';
import Footer from 'components/Footer/Footer';
import Header from 'components/Header/Header';
import HeaderControls from 'components/HeaderControls/HeaderControls';
import MobileWarning from 'components/MobileWarning/MobileWarning';

export default function Main({ children, fullScreenHandle }: MainProps) {
    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <DocHead />
            <Box component="main" display="flex" flex={1} flexDirection="column" order={2} position="relative">
                <MobileWarning minWidth={850}>{children}</MobileWarning>
            </Box>
            {!fullScreenHandle.active && (
                <>
                    <Header>
                        <HeaderControls fullScreenHandle={fullScreenHandle} />
                    </Header>
                    <Footer />
                </>
            )}
        </Box>
    );
}
